import type { ComponentContentSchema } from '@vibesites/runtime';
import { useBlockSlot, SectionContextProvider, EditableToken } from '@vibesites/runtime/react';

/** The Multihub tour scheduler on the page's paper background, held to a readable width. */
export function TourScheduler() {
  const slot = useBlockSlot('tourscheduler.widget', { defaultValue: 'multihub-tour-scheduler' });

  return (
    <section className="bg-[--q-paper] px-[--gutter] py-12 max-[767px]:py-8" id="schedule">
      <EditableToken
        path="tourscheduler.widget"
        type="block"
        as="div"
        className="mx-auto w-full max-w-2xl [--vibe-color-background:var(--q-paper)]"
      >
        {slot && (
          <SectionContextProvider sectionId={slot.sectionId}>
            <slot.BlockComponent sectionId={slot.sectionId} />
          </SectionContextProvider>
        )}
      </EditableToken>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'TourScheduler',
  displayName: 'Tour Scheduler',
  tokens: {
    'tourscheduler.widget': {
      label: 'Tour Scheduler',
      type: 'block',
      defaultValue: 'multihub-tour-scheduler',
      acceptedBlockCategories: ['Forms'],
    },
  },
};

(TourScheduler as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default TourScheduler;
